<template>
  <PopUp
    :max-height="90"
    v-if="isFreeToProPopupVisible"
    close-button
    close-button-variant="black"
    @close="closeFreeToProPopup"
  >
    <div class="upgrade-popup">
      <div class="upgrade-popup__image free-to-pro"></div>
      <div class="upgrade-popup__main-block">
        <div class="upgrade-popup__title">Upgrade to unlock this feature and many more amazing
          others
        </div>
        <ul class="upgrade-popup__items">
          <li
            class="upgrade-popup__item"
            v-for="(benefit,index) in upgradeBenefits"
            :key="index"
          >
            <img
              class="item__icon"
              :src="benefit.icon"
              :alt="benefit.alt"
            >
            <div class="item__text">{{ benefit.text }}</div>
          </li>
        </ul>
        <a
          @click="goToPricingPage"
          class="button-brand upgrade-popup__button"
        >Learn more
        </a>
        <div
          role="button"
          class="upgrade-popup__text"
          @click="closeFreeToProPopup"
        >No thanks, maybe later
        </div>
      </div>
    </div>
  </PopUp>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import PopUp from '@/components/PopUp';

export default {
  name: 'FreeToProUpgradePopup',
  components: { PopUp },
  computed: {
    ...mapGetters({
      isFreeToProPopupVisible: 'isFreeToProPopupVisible',
    }),
    upgradeBenefits() {
      return [
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/tryb.svg'),
          text: 'Remove the Tryb logo',
          alt: 'Tryb logo',
        },
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/analytics.svg'),
          text: 'Comprehensive analytics',
          alt: 'Analytics diagram',
        },
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/build.svg'),
          text: 'Build and sell online courses',
          alt: 'Course builder',
        },
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/access.svg'),
          text: 'Access extra content storage ',
          alt: 'Content storage',
        },
      ];
    },
  },
  methods: {
    ...mapMutations({
      closeFreeToProPopup: 'closeFreeToProPopup',
    }),
    async goToPricingPage() {
      this.closeFreeToProPopup();
      await this.$router.push({ name: 'Pricing' });
    },
  },
};
</script>
